import { render } from "./ShareAndEarn.vue?vue&type=template&id=5988a37c&ts=true"
import script from "./ShareAndEarn.vue?vue&type=script&lang=ts"
export * from "./ShareAndEarn.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__